module.exports = __webpack_public_path__ + "img/common_service_2.e1f8db42.png";